module.exports = __webpack_public_path__ + "static/media/locate.ddc7ce23.svg";